/**
 * 1. CART MONITOR
 * Detects changes in cart total price and resets the "Hidden" status of the popup
 * so it can reappear if the cart value changes (triggering new tiers/gifts).
 */
;(function () {
  const STORAGE_KEY_POPUP = 'FGSECOMAPP_HIDDEN_GIFT_POPUP'
  const STORAGE_KEY_TOTAL = 'bogos_cart_total'

  // Core logic to compare totals and reset local storage
  const checkPriceChange = (currentTotal) => {
    if (typeof currentTotal === 'undefined' || currentTotal === null) return

    const storedTotal = localStorage.getItem(STORAGE_KEY_TOTAL)

    // If we have a stored total and it's different from current, reset the popup key
    if (storedTotal !== null && parseInt(storedTotal) !== currentTotal) {
      localStorage.removeItem(STORAGE_KEY_POPUP)
    }

    // Always update the stored total to the current one
    localStorage.setItem(STORAGE_KEY_TOTAL, currentTotal)
  }

  // Helper to process response data
  const processCartResponse = (data) => {
    if (!data) return

    // Scenario A: The response IS the cart (update.js, change.js, get)
    if (typeof data.total_price !== 'undefined') {
      checkPriceChange(data.total_price)
    }
    // Scenario B: The response is an Item (add.js), so we don't know the total yet.
    // We must fetch the full cart to get the new total.
    else {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => checkPriceChange(cart.total_price))
        .catch(() => {})
    }
  }

  // Initial Sync: only fetch on first visit — subsequent loads use the stored value as baseline.
  // The interceptor will update it on the next real cart mutation.
  if (localStorage.getItem(STORAGE_KEY_TOTAL) === null) {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => checkPriceChange(cart.total_price))
      .catch(() => {})
  }

  // --- INTERCEPTOR 1: FETCH API ---
  const originalFetch = window.fetch
  window.fetch = function (...args) {
    const fetchPromise = originalFetch.apply(this, args)

    fetchPromise.then((res) => {
      // Robust URL check handling string URLs or Request objects
      const url = (typeof args[0] === 'string' ? args[0] : args[0].url || '').toLowerCase()

      // We only care about calls to the cart API
      if (url.includes('/cart') && (url.includes('.js') || url.includes('json'))) {
        // Clone the response so we don't consume the stream for the actual app
        const clone = res.clone()
        clone
          .json()
          .then(processCartResponse)
          .catch(() => {})
      }
    }).catch(() => {})

    return fetchPromise
  }

  // --- INTERCEPTOR 2: XMLHTTPREQUEST (jQuery/AJAX) ---
  const originalOpen = XMLHttpRequest.prototype.open
  const originalSend = XMLHttpRequest.prototype.send

  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url // Store URL to check later
    return originalOpen.apply(this, arguments)
  }

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      const url = (this._url || this.responseURL || '').toLowerCase()

      if (url.includes('/cart') && (url.includes('.js') || url.includes('json'))) {
        try {
          const data = JSON.parse(this.responseText)
          processCartResponse(data)
        } catch (e) {
          // Ignore JSON parse errors
        }
      }
    })
    return originalSend.apply(this, arguments)
  }
})()

/**
 * 2. MUTATION OBSERVER
 * Watches for the popup to appear, checks the box visually, and saves preference on dismiss.
 */
const bogosObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    // Check if nodes were added to the DOM
    if (mutation.addedNodes.length) {
      // 1. Look for the specific checkbox
      const checkbox = document.querySelector('.sca-disable-checkbox')

      // If found and not yet checked
      if (checkbox && !checkbox.checked) {
        // VISUAL ONLY: Check the box so the user sees it selected.
        // We do NOT dispatch the 'change' event here, so the app doesn't auto-close or save yet.
        checkbox.checked = true

        // Define the logic to save to LocalStorage
        const savePreferenceOnDismiss = () => {
          // Double-check: Did the user uncheck it before closing?
          if (checkbox.checked) {
            // Save the current timestamp, mimicking the app's native behavior
            localStorage.setItem('FGSECOMAPP_HIDDEN_GIFT_POPUP', Date.now().toString())
          }
        }

        // 2. Attach listeners to "Close" buttons (X icons, etc.)
        // The app uses various classes/attributes for close buttons:
        // .sca-close-modal-fg, [data-close], .bogos-slider-close-btn
        const closeButtons = document.querySelectorAll(
          '.sca-close-modal-fg, [data-close], .bogos-slider-close-btn'
        )

        closeButtons.forEach((btn) => {
          // Avoid attaching multiple listeners to the same button
          if (!btn.dataset.bogosDismissAttached) {
            btn.addEventListener('click', savePreferenceOnDismiss)
            btn.dataset.bogosDismissAttached = 'true' // Mark as attached
          }
        })

        // 3. Attach listener to the Background Overlay (Clicking outside)
        const container = document.querySelector('#freegifts-main-popup-container')
        if (container && !container.dataset.bogosDismissAttached) {
          container.addEventListener('click', (e) => {
            // Only trigger if clicking the container background directly (not the inner content)
            if (e.target === container) {
              savePreferenceOnDismiss()
            }
          })
          container.dataset.bogosDismissAttached = 'true'
        }
      }
    }
  })
})

// Start observing the document body for added elements
bogosObserver.observe(document.body, {
  childList: true,
  subtree: true,
})
